<template>
  <v-app id="app" v-scroll="onScroll">
    <v-content v-if="!plainTemplate">

      <navigation-messages v-if="!maintenance"></navigation-messages>

      <navigation-drawer
        v-if="!maintenance"
        :menuItems="menuItems"
      ></navigation-drawer>

      <navigation-top
        v-if="!maintenance"
        :shortHeader="shortHeader"
        :staticNavbar="staticNavbar"
      ></navigation-top>

      <navigation-bottom
        :shortHeader="shortHeader"
        :showNavBottom="showNavBottom"
        :staticNavbar="staticNavbar"
        :maintenance="maintenance"
      ></navigation-bottom>

      <navigation-quick-menu
        v-if="showQuickMenu"
        :staticNavbar="staticNavbar"
        :menuItems="quickMenuItems"
      ></navigation-quick-menu>

      <navigation-menu
        v-if="showMenu"
        :staticNavbar="staticNavbar"
        :menuItems="menuItems"
      ></navigation-menu>

      <navigation-no-ownership
        v-if="showNoOwnershipNote"
      ></navigation-no-ownership>
    </v-content>

    <v-content style="min-height:720px!important;" :class="{'is-short-header': staticNavbar}">
      <page-title
        v-if="!plainTemplate"
        :title="storePage.key"
        :icon="storePage.icon"
        :color="storePage.color"
        :alignment="storePage.alignment"
      ></page-title>

      <page-breadcrumb v-if="!plainTemplate" :breadcrumb="storeBreadcrumb"></page-breadcrumb>

      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>

    <div v-if="!plainTemplate">
      <div v-if="storeUser && storeUser.isForeign">
        <v-btn
          :color="storeAdminElements ? 'purple' : 'warning'"
          fab
          large
          fixed
          top
          left
          style="margin: 30px 0 0 25px"
          @click="toggleAdminElements"
        >
          <v-icon color="white" style="display: inline-flex !important;">fa-warning</v-icon>
        </v-btn>
        <v-btn
          :color="storeAdminElements ? 'purple' : 'warning'"
          fab
          large
          fixed
          top
          right
          style="margin: 30px 25px 0 0"
          @click="toggleAdminElements"
        >
          <v-icon color="white" style="display: inline-flex !important;">fa-warning</v-icon>
        </v-btn>
        <v-btn
          v-if="!storeUser.idOrig"
          color="warning"
          fab
          large
          fixed
          bottom
          left
          style="margin: 0 0 25px 25px"
        >
          <v-icon color="white" style="display: inline-flex !important;">fa-warning</v-icon>
        </v-btn>
        <v-btn
          v-if="!storeUser.idOrig"
          color="warning"
          fab
          large
          fixed
          bottom
          right
          style="margin: 0 25px 25px 0"
        >
          <v-icon color="white" style="display: inline-flex !important;">fa-warning</v-icon>
        </v-btn>
      </div>

      <div v-if="!storePage.noImageFooter" :class="{'spacer-before-footer': showFooter}">
        <v-fab-transition v-model="fab">
          <v-btn
            color="primary"
            dark
            fab
            v-show="fab"
            fixed
            bottom
            right
            @click="scrollToTop()"
            style="margin-bottom: 15px"
          >
            <v-icon style="display: inline-flex !important;">keyboard_arrow_up</v-icon>
          </v-btn>
        </v-fab-transition>
      </div>

      <cookie-law
        class="text-xs-left"
        theme="dark-lime"
        :buttonText="`${$t('general.iUnderstand')}`"
      >
        <div slot="message">
          {{ this.$t('general.useCookies') }}
          <br/>
          {{ this.$t('cookies.useVBusnet') }}
          <br/>
          {{ this.$t('cookies.privacyPolicy') }}
          <router-link style="text-decoration: underline" :to="{name: 'PrivacyPolicy'}">{{ $t('eula.privacyPolicy') }}</router-link>.
        </div>
      </cookie-law>
      <navigation-footer v-if="!maintenance"></navigation-footer>
      <navigation-short-footer v-else></navigation-short-footer>

    </div>

  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import browserInfo from 'browser-info'
import { mapGetters } from 'vuex'
import account from '@/client/lib/account'

const Payment = () => import('@/client/components/Payment')
const PageTitle = () => import('@/client/components/public/PageTitle')
const PageBreadcrumb = () => import('@/client/components/public/PageBreadcrumb')

const NavigationTop = () => import('@/client/components/Navigation/Top')
const NavigationBottom = () => import('@/client/components/Navigation/Bottom')
const NavigationDrawer = () => import('@/client/components/Navigation/Drawer')
const NavigationFooter = () => import('@/client/components/Navigation/Footer')
const NavigationShortFooter = () => import('@/client/components/Navigation/ShortFooter')
const NavigationQuickMenu = () => import('@/client/components/Navigation/QuickMenu')
const NavigationMenu = () => import('@/client/components/Navigation/Menu')
const NavigationMessages = () => import('@/client/components/Navigation/Messages')
const NavigationNoOwnership = () => import('@/client/components/Navigation/NoOwnership')

export default {
  components: {
    Payment,
    CookieLaw,
    PageTitle,
    PageBreadcrumb,
    NavigationQuickMenu,
    NavigationNoOwnership,
    NavigationShortFooter,
    NavigationTop,
    NavigationBottom,
    NavigationDrawer,
    NavigationFooter,
    NavigationMessages,
    NavigationMenu
  },
  mounted () {
    if (this.$route.params && this.$route.params.maintenance === true) {
      this.maintenance = true
    }
    this.plainTemplate = this.storePage.plainTemplate
    if (this.storeAuth.authorized) {
      this.getAuthorizedMenuItems()
    } else {
      this.getInitialMenuItems()
    }

    this.$store.commit('setBrowserInfo', browserInfo())

    this.updateErrorLog()
    this.initExperimentalFeatures()
  },
  data () {
    return {
      interval: null,
      plainTemplate: false,
      showNavBottom: true,
      orderPRO: false,
      shortHeader: false,
      menuItems: [],
      quickMenuItems: [],
      fab: false,
      offsetTop: 0,
      noOwnerships: false,
      maintenance: false,
      staticNavbarActicated: false
    }
  },
  computed: {
    ...mapGetters([
      'storeAuth',
      'storeMeta',
      'storePage',
      'storeUser',
      'storeBreadcrumb',
      'storeSettings',
      'storeAdminElements'
    ]),
    staticNavbar: function () {
      if (this.staticNavbarActicated) {
        return this.offsetTop > 275 && this.$vuetify.breakpoint.mdAndUp
      } else {
        return false
      }
    },
    showNoOwnershipNote: function () {
      return !this.maintenance && this.storeUser && this.noOwnerships && this.storeUser.valid_ownership_count === 0
    },
    showMenu: function () {
      return !this.maintenance && this.storeAuth.authorized && !this.storeSettings.menutype
    },
    showQuickMenu: function () {
      return !this.maintenance && this.storeAuth.authorized && this.storeSettings.menutype
    },
    accountInfo: function () {
      if (this.$store.state.user) {
        return account.info(this.$store.state.user.subscription, this.$store.state.user.subscription_valid_until)
      }
    },
    showFooter: function () {
      let show = true
      if (this.storeMeta && this.storeMeta.footer) {
        if (this.storeMeta.footer.spacer === false) {
          show = false
        }
      }
      return show
    }
  },
  watch: {
    $route (to, from) {
      if (!this.storeAuth.authorized && to.name === 'Index') {
        this.showNavBottom = true
      } else {
        this.showNavBottom = true
      }

      if (to.meta && to.meta.page) {
        this.shortHeader = to.meta.page.shortHeader || false
        this.maintenance = to.meta.page.maintenance || false
      }
      if (to.name !== 'OwnershipClaim') {
        this.noOwnerships = true
      } else {
        this.noOwnerships = false
      }
    },
    storeAuth () {
      if (this.storeAuth.authorized) {
        this.getAuthorizedMenuItems()
        this.updateErrorLog()
      } else {
        this.destroyInterval()
        this.getInitialMenuItems()
        this.$router.push('/')
      }
    }
  },
  methods: {
    toggleAdminElements () {
      this.$store.commit('toggleAdminElements')
    },
    initExperimentalFeatures () {
      if (window.localStorage) {
        const option = localStorage.getItem('option')
        if (option) {
          if (option === 'navbar') {
            console.log('EXPERIMENTAL FEATURE %s ACTIVATED', option)
            this.staticNavbarActicated = true
          }
        }
      }
    },
    destroyInterval () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    updateErrorLog () {
      if (this.storeUser && this.storeUser.isProfessional && this.showQuickMenu) {
        if (!this.interval && this.$environment !== 'development') {
          this.interval = setInterval(() => {
            this.updateErrorLog()
            // crontab is running */5 * * * *
          }, 150 * 1000)
        }
        this.$http.get('monitoring/error-logs', {}).then(response => {
          let errorLogs = []
          if (response && response.status === 200) {
            if (response.data && typeof response.data === 'object') {
              if (response.data.error && response.data.error === 401) {

              } else {
                response.data.forEach(data => {
                  if (data.errorCount) {
                    errorLogs.push(data)
                  }
                })
              }
            }
          }
          this.$store.commit('setErrorLogs', errorLogs)
        })
      }
    },
    onScroll (e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      this.offsetTop > 1500 ? this.fab = true : this.fab = false
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    getAuthorizedMenuItems () {
      const menuItems = [
        {
          title: 'general.information',
          titleIcon: 'fa-info',
          category: 'information',
          items: [
            {
              name: 'howto.question',
              icon: 'fa-book fa-fw',
              action: 'Information'
            }, {
              name: 'customer.examples',
              icon: 'fa-external-link-square fa-fw',
              action: 'CustomerExamples',
              vendor: 'resol'
            }, {
              name: 'general.helpAndSupport',
              icon: 'fa-question-circle fa-fw',
              action: 'HelpAndSupport'
            }, {
              name: 'general.Versionsvergleich',
              icon: 'compare_arrows',
              action: 'VersionComparison',
              vendor: 'resol'
            }
          ]
        },
        {
          title: 'sideBar.myVBusNet',
          titleIcon: 'fa-home',
          items: [
            {
              name: 'sideBar.dashboard',
              icon: 'dashboard',
              action: 'Dashboard'
            }, {
              name: 'general.messages',
              icon: 'mail',
              action: 'Messages'
            }, {
              name: 'subtitle.myDevices',
              icon: 'view_list',
              action: 'Devices'
            }, {
              name: 'general.preferences',
              icon: 'settings',
              action: 'Settings'
            }
          ]
        },
        {
          title: 'sideBar.visualization',
          titleIcon: 'fa-area-chart',
          items: [
            {
              name: 'sideBar.filters',
              icon: 'fa-filter fa-fw',
              action: 'Filters'
            }, {
              name: 'sideBar.images',
              icon: 'fa-picture-o fa-fw',
              action: 'Images'
            }, {
              name: 'sideBar.liveSchemes',
              icon: 'fa-object-group fa-fw',
              action: 'LiveSystems'
            }, {
              name: 'sideBar.diagrams',
              icon: 'fa-line-chart fa-fw',
              action: 'Diagrams'
            }, {
              name: 'sideBar.downloads',
              icon: 'fa-download fa-fw',
              action: 'Downloads'
            }, {
              name: 'visualization.scheduledDownloads',
              icon: 'fa-calendar fa-fw',
              action: 'Reports',
              requires: 'pro'
            }, {
              name: 'sideBar.reports',
              icon: 'fa-file-text-o fa-fw',
              action: 'Extended-Reports',
              requires: 'pro'
            }
          ]
        },
        {
          title: 'sideBar.monitoring',
          titleIcon: 'fa-bell',
          requires: 'pro',
          items: [
            {
              name: 'sideBar.notifications',
              icon: 'fa-bullhorn fa-fw',
              action: 'Notifications',
              requires: 'pro'
            }, {
              name: 'monitoring.errorLog',
              icon: 'fa-exclamation-triangle fa-fw',
              action: 'Error-Logs',
              requires: 'pro'
            }
          ]
        }
      ]

      this.menuItems = []
      this.quickMenuItems = []

      if (this.storeUser) {
        menuItems.forEach(item => {
          if (item.requires) {
            if (item.requires === 'pro' && this.storeUser.isProfessional) {
              const subItems = item.items
              item.items = []
              subItems.forEach(subItem => {
                if (subItem.requires) {
                  if (subItem.requires === 'pro' && this.storeUser.isProfessional) {
                    if (subItem.vendor && subItem.vendor !== this.$VENDOR) {
                      // hide for other vendors
                    } else {
                      item.items.push(subItem)
                    }
                    if (subItem.action !== 'Settings') {
                      this.quickMenuItems.push(subItem)
                    }
                  }
                } else {
                  if (subItem.vendor && subItem.vendor !== this.$VENDOR) {
                    // hide for other vendors
                  } else {
                    item.items.push(subItem)
                  }
                  if (subItem.action !== 'Settings') {
                    this.quickMenuItems.push(subItem)
                  }
                }
              })
              this.menuItems.push(item)
            }
          } else {
            const subItems = item.items
            item.items = []
            subItems.forEach(subItem => {
              if (subItem.requires) {
                if (subItem.requires === 'pro' && this.storeUser.isProfessional) {
                  if (subItem.vendor && subItem.vendor !== this.$VENDOR) {
                    // hide for other vendors
                  } else {
                    item.items.push(subItem)
                  }
                  if (subItem.action !== 'Settings' && item.category !== 'information') {
                    this.quickMenuItems.push(subItem)
                  }
                }
              } else {
                if (subItem.vendor && subItem.vendor !== this.$VENDOR) {
                  // hide for other vendors
                } else {
                  item.items.push(subItem)
                }
                if (subItem.action !== 'Settings' && item.category !== 'information') {
                  this.quickMenuItems.push(subItem)
                }
              }
            })
            this.menuItems.push(item)
          }
        })
      }
    },
    getInitialMenuItems () {
      this.menuItems = [
        {
          title: 'general.information',
          titleIcon: 'fa-info',
          items: []
        }
      ]

      const subItems = [
        {
          name: 'howto.question',
          icon: 'fa-book fa-fw',
          action: 'Information'
        }, {
          name: 'customer.examples',
          icon: 'fa-external-link-square fa-fw',
          action: 'CustomerExamples',
          vendor: 'resol'
        }, {
          name: 'general.helpAndSupport',
          icon: 'fa-question-circle fa-fw',
          action: 'HelpAndSupport'
        }, {
          name: 'general.Versionsvergleich',
          icon: 'compare_arrows',
          action: 'VersionComparison',
          vendor: 'resol'
        }
      ]

      for (const subItem of subItems) {
        if (subItem.vendor && subItem.vendor !== this.$VENDOR) {
          // hide for other vendors
        } else {
          this.menuItems[0].items.push(subItem)
        }
      }
      this.quickMenuItems = []
      for (const item of this.menuItems) {
        for (const subItem of item.items) {
          this.quickMenuItems.push(subItem)
        }
      }
    }
  }
}
</script>

<style>
body {
  color: #696969;
}
h1, h2, h3, h4, h5, h6 {
  font-family: 'Open Sans', sans-serif;
  font-weight: lighter;
  color: #696969;
  margin-bottom: 10px;
  margin-top: 20px;
}
h1 {
  font-size: 25px;
  margin-bottom: 10px;
  font-weight: 300;
}
h2 {
  font-size: 22px;
  font-weight: 300;
}
h3 {
  font-size: 18px;
  font-weight: 300;
}
/* a, a:visited, a:active {
  color: rgba(0,0,0,.54)!important;
  text-decoration: none;
} a:hover {
  color: rgba(0,0,0,.9)!important;
  text-decoration: none;
} */

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: local('Open Sans Regular'),
       local('Open Sans'),
       url('../static/fonts/Regular/OpenSans-Regular.woff2') format('woff2'),
       url('../static/fonts/Regular/OpenSans-Regular.woff') format('woff'),
       url('../static/fonts/Regular/OpenSans-Regular.ttf') format('truetype'),
       url('../static/fonts/Regular/OpenSans-Regular.svg') format('svg');
}

@font-face {
  font-family: 'RESOL';
  src:
       url('../static/fonts/RESOL.woff') format('woff'),
       url('../static/fonts/RESOL.ttf') format('truetype'),
       url('../static/fonts/RESOL.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^="resol-"], [class*=" resol-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'RESOL' !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: rgba(0,0,0,0.54);

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.resol-Drehzahl:before {
  content: "\e900";
}
.resol-Ladelogik:before {
  content: "\e901";
}
.resol-Relays:before {
  content: "\e902";
}
.resol-Tastenkreuz:before {
  content: "\e903";
}
.resol-DeltaSol-MX:before {
  content: "\e904";
}
.resol-DeltaSol-A:before {
  content: "\e905";
}
.resol-DeltaSol-BX:before {
  content: "\e906";
}
.resol-DeltaSol-SL:before {
  content: "\e907";
}
.resol-DeltaSol-CS:before {
  content: "\e908";
}
.resol-RESOL_Logo:before {
  content: "\e909";
}
.resol-VBus:before {
  content: "\e90a";
}
.resol-Solarstationen_Icon:before {
  content: "\e90b";
}
.resol-DeltaSol-SL_Icon:before {
  content: "\e90c";
}
.resol-DeltaSol-CS_Icon:before {
  content: "\e90d";
}
.resol-Solarregler_Icon:before {
  content: "\e90e";
}
.resol-RPT_Icon:before {
  content: "\e90f";
}
.resol-Ersatzteile_Icon:before {
  content: "\e910";
}
.resol-Sommer_oder_Winter:before {
  content: "\e911";
}
.resol-Heizung:before {
  content: "\e912";
}
.resol-Haus_2:before {
  content: "\e913";
}
.resol-Aussentemperatur_2:before {
  content: "\e914";
}
.resol-Haus_1:before {
  content: "\e915";
}
.resol-Aussentemperatur_1:before {
  content: "\e916";
}
.resol-Sommerbetrieb:before {
  content: "\e917";
}
.resol-Zieltemperatur:before {
  content: "\e918";
}
.resol-Thermische-Desinfektion:before {
  content: "\e919";
}
.resol-Anlage:before {
  content: "\e91a";
}
.resol-Schraubenschlussel:before {
  content: "\e91b";
}
.resol-Zahnrad_Grundeinstellung:before {
  content: "\e91c";
}
.resol-Thermometer:before {
  content: "\e91d";
}
.resol-Einstellungen:before {
  content: "\e91e";
}
.resol-Warmemengenzahlung:before {
  content: "\e91f";
}
.resol-Sonne:before {
  content: "\e920";
}
.resol-Frost:before {
  content: "\e921";
}
.resol-Solar:before {
  content: "\e922";
}
.resol-Nachheizung:before {
  content: "\e923";
}
.resol-Sommer-oder-Winter:before {
  content: "\e924";
}
.resol-Haus:before {
  content: "\e925";
}
.resol-Aussentemperatur:before {
  content: "\e926";
}

#app {
  position: relative;
}
#app .v-alert .success {
  background-color: #69a341!important;
}
#app .v-alert .info {
  background-color: rgba(33, 150, 243, .8)!important;
}
#app .v-alert .warning {
  background-color: rgba(255, 193, 7, .8)!important;
}
#app .v-alert .error {
  background-color: rgba(255, 82, 82, .8)!important;
}
#app .v-alert .primary {
  background-color: rgba(25, 118, 210, .8)!important;
}
#app .v-alert .secondary {
  background-color: rgba(66, 66, 66, .8)!important;
}
.v-alert {
  color: rgba(0,0,0,0.5);
}

/* #app .primary {
  background-color: rgb(63, 165, 53)!important;
  border-color: #558435 !important;
  color: white;
} */

.application .theme--light.v-expansion-panel .v-expansion-panel__container, .theme--light .v-expansion-panel .v-expansion-panel__container {
  padding-top: 8px;
  padding-bottom: 6px;
}
.v-expansion-panel {
  list-style-type: none;
}
.v-expansion-panel__header {
  height: auto;
}
.v-toolbar__content, .v-toolbar__extension {
  padding-top: 15px;
  padding-right: 0px;
}
.toolbar__title {
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.toolbar__title:hover {
  background-color: #d4d4d1;
}
.list__tile__action, .list__tile__avatar {
  min-width: 36px;
}
.v-list__tile__action, .v-list__tile__avatar {
  min-width: 36px;
}
.toolbar__content, .toolbar__extension {
  display: block;
  width: 100%;
  margin-top: 20px;
}
.swal2-popup {
  color: #696969;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
}
.swal2-font {
  font-family: "Open Sans", sans-serif;
}
#app .swal2-container {
  font-family: "Open Sans", sans-serif;
}
#swal2-content {
  text-align: left!important;
}
.application .theme--light.v-card, .theme--light .v-card {
  color: #696969;
}
.container {
  max-width: 980px!important;
  padding-left: 10px!important;
  padding-right: 10px!important;
  padding-bottom: 0px;
}
#app .success--text {
  color: #69a341!important;
}
.v-tabs__icon {
  padding-top: 12px;
}
.application .theme--light.v-label, .theme--light .v-label {
  color: #333
}
.v-btn--active span {
  color: #f5f5f2!important;
}
.swal2-container {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif!important;
}
.swal2-content {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif!important;
}
#swal2-content {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif!important;
}
.swal2-popup {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif!important;
}
.open-sans {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif!important;
}
.v-badge__badge {
  margin-top: 5px!important;
  width: 10px!important;
  height: 10px!important;
}
</style>

<style scoped>

#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #696969;
  padding-top: 0px;
  background-color: #fff;
  position: relative;
}
.nowrap {
  white-space: nowrap;
}
.toolbar {
  background-color: transparent;
}
.input-group {
  padding-top: 0px
}
.hide-drawer {
  cursor: pointer;
}
ul.list {
  background-color: #f5f5f2;
}
.spacer-before-footer {
  margin-top: 20px;
  height: 250px;
  background-image: url(../static/images/footer_VBus.png);
  background-repeat: repeat-x;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .2s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
.padding-xs {
  margin-top: 25px;
}
a, a:visited, a:hover, a:active {
  color: inherit!important;
  text-decoration: none;
}
.footer-infos p {
  opacity: .8;
}
.single-widget h2 {
  color: #69a341;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 15px;
}
.is-short-header {
  margin-top: 250px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue